export const SWISH_METHOD = 'Payments.Electra.Swish';
export const TELIAPAY_METHOD = 'Payments.Electra.TeliaPay';
export const CARD_PAYMENT_METHOD = 'Payments.Electra.Netaxept.CardPayment';
export const CASH_ON_DELIVERY = 'Payments.Electra.CashOnDelivery';
export const ELECTRAFINANS_METHOD = 'Payments.Electra.ElectraFinans';
export const INVOICE_PAYMENT_METHOD = 'pay-by-invoice';

export const PAYMENT_METHODS_THAT_ARE_MONTHLY_PAYMENT = [
  TELIAPAY_METHOD,
  ELECTRAFINANS_METHOD,
];
